import { CreateOrganization$Params } from '../../../../core/clients/omni-core/functions';
import { Organization, OrganizationResponse } from '../../../../core/clients/omni-core/models';

export type OrganizationCreateFormModel = Omit<CreateOrganization$Params['body'], 'name'> & {
  address: CreateOrganization$Params['body']['address'] & {
    streetNumberSuffix: string;
  };

  hasDifferentBillingAddress: boolean;
  billingAddress: CreateOrganization$Params['body']['address'] & {
    streetNumberSuffix: string;
  };
};

export const toModel = (
  organization: OrganizationResponse | null,
): OrganizationCreateFormModel => ({
  address: {
    city: organization?.address?.city ?? '',
    street: organization?.address?.street ?? '',
    streetNumber: organization?.address?.streetNumber ?? '',
    streetNumberSuffix: organization?.address?.streetNumberSuffix ?? '',
    zipCode: organization?.address?.zipCode ?? '',
  },

  hasDifferentBillingAddress:
    JSON.stringify(organization?.address) !== JSON.stringify(organization?.billingAddress),

  billingAddress: {
    city: organization?.billingAddress?.city ?? '',
    street: organization?.billingAddress?.street ?? '',
    streetNumber: organization?.billingAddress?.streetNumber ?? '',
    streetNumberSuffix: organization?.billingAddress?.streetNumberSuffix ?? '',
    zipCode: organization?.billingAddress?.zipCode ?? '',
  },
});

const normalizeAddress = (address: OrganizationCreateFormModel['address']) => {
  return {
    street: address.street,
    streetNumber: address.streetNumber,
    streetNumberSuffix: address.streetNumberSuffix || undefined,
    city: address.city,
    zipCode: address.zipCode,
  };
};

export const toPayload = (data: OrganizationCreateFormModel): Partial<Organization> => {
  const normalizedAddress = normalizeAddress(data.address);
  const normalizedBillingAddress = data.hasDifferentBillingAddress
    ? normalizeAddress(data.billingAddress)
    : normalizedAddress;
  return {
    address: normalizedAddress,
    billingAddress: normalizedBillingAddress,
  };
};
